
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-huddles",
      function () {
        return require("private-next-pages/my-huddles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-huddles"])
      });
    }
  